'use client';

import { twMerge } from '@shared/themes';
import { useTranslations } from 'next-intl';
import { Summary, SummaryContent, SummaryItem } from '../../../Summary/Summary';
import { getPurchaseSummaryItems } from '../../purchase-summary/getPurchaseSummaryItems';
import { usePurchaseDetails } from '../context/PurchaseDetailsContext';

type PurchaseDetailsExtrasSummaryProps = {
  className?: string;
};

/**
 * Renders the purchase extras summary; hidden while older participations are shown.
 * Reads its data from `PurchaseDetailsProvider`, so it must be rendered inside it.
 */
function PurchaseDetailsExtrasSummary({ className }: PurchaseDetailsExtrasSummaryProps) {
  const t = useTranslations('lotteries');
  const { ticket, lotteryName, activeParticipation, dyjPlayed, numberOfDraws, showOlderParticipationsInfo } = usePurchaseDetails();
  const { renewType, duration, lineInfo, options } = ticket;

  if (showOlderParticipationsInfo) return null;

  const summaryItems = getPurchaseSummaryItems({
    lotteryName,
    renewType,
    duration,
    lineCount: lineInfo[lotteryName]?.length ?? 0,
    dyjPlayed,
    options: options ?? [],
    participation: activeParticipation,
    numberOfDraws,
  });

  return (
    <Summary className={twMerge('ll-container-inner', className)}>
      <SummaryContent>
        {summaryItems.map(item => (
          <SummaryItem key={item.id} label={t(item.translationKey, item.translationParams)} value="" />
        ))}
      </SummaryContent>
    </Summary>
  );
}

export { PurchaseDetailsExtrasSummary, type PurchaseDetailsExtrasSummaryProps };
